import { IconHourglass, IconProgress, IconCheck } from "@tabler/icons-react";

export const enum OrganizerStatus {
  NOT_STARTED = "not started",
  IN_PROGRESS = "in progress",
  COMPLETE = "complete",
}

export const statusConfigs: Record<string, any> = {
  [OrganizerStatus.NOT_STARTED]: {
    icon: IconHourglass,
    color: "#4D5357",
    text: "Not Started",
    backgroundColor: "#DBDFE4",
  },
  [OrganizerStatus.IN_PROGRESS]: {
    icon: IconProgress,
    color: "#0A4A6E",
    text: "In Progress",
    backgroundColor: "#D6F0FF",
  },
  [OrganizerStatus.COMPLETE]: {
    icon: IconCheck,
    color: "#1D892F",
    text: "Completed",
    backgroundColor: "#CAF6D2",
  },
};

export const OrganizerPages = {
  REVIEW: "reviewAll",
  ADDITIONAL_QUESTIONS: "additionalQuestions",
  DISCLOSURE_AGREEMENT: "confirm",
};

export const MISSING_ANSWERS_ADDITIONAL_QUESTIONS_PAGE =
  "Some required questions still need your answers. Please review and complete them before proceeding.";
export const MISSING_ANSWERS_REVIEW_PAGE =
  "Some questions in `Additional Questions` still need your answers. Please review and complete them before proceeding.";
export const ALWAYS_SAVE_PAGES = ["comments"];

export const optionalPages = [
  "comments",
  OrganizerPages.REVIEW,
  "uploadDocsOther",
  // "previousYears",
];
